
<button (click)="openDialog()">Add Rule</button>
